import client from './client';

/**
 * Flattens the slot-keyed banner maps back into the `desktop_banner_4` style keys the page
 * components read, so nothing downstream of the store has to change.
 */
function flattenBanners(banners, prefix) {
  return Object.entries(banners || {}).reduce((flat, [slot, url]) => {
    flat[`${prefix}_${slot}`] = url;
    return flat;
  }, {});
}

export function mapBrand(dto) {
  return {
    id: dto.id,
    brand_name: dto.brandName,
    brand_domain: dto.brandDomain,
    footer: dto.footer,
    logo_header: dto.logoHeader,
    logo_footer: dto.logoFooter,
    terms_conditions: dto.termsConditions,
    policy: dto.policy,
    cookie_policy: dto.cookiePolicy,
    ...flattenBanners(dto.desktopBanners, 'desktop_banner'),
    ...flattenBanners(dto.mobileBanners, 'mobile_banner'),
  };
}

/** Turns the CSS rows into the `{ property: value }` map the components bind against. */
export function mapBrandCss(css) {
  return (css || []).reduce((styles, item) => {
    styles[item.cssProperty] = item.cssValue;
    return styles;
  }, {});
}

/**
 * Brand and theme in one request. VapCore serves both together because the portal cannot paint
 * anything until it has them, and this runs in the router guard before the first screen.
 */
export async function fetchBranding(domain) {
  const response = await client.get('/api/care-portal/branding', {
    params: { domain },
  });

  return {
    brand: mapBrand(response.data.brand),
    brandCSS: mapBrandCss(response.data.css),
  };
}
